export const ui = {
    accordionMovies: document.querySelector('.accordion-movies') as HTMLElement,
    accordionPictures : document.querySelector('.accordion-pictures') as HTMLElement,
    accordionEnrichments : document.querySelector('.accordion-enrichments') as HTMLElement
} 